import * as React from 'react'

import { MortgageStep } from 'even-ts-static'

import Application from './Application/container'
import Results from './Results'

interface Props {
  selectedStep: MortgageStep
}

export const Mortgage: React.FC<Props> = (props) => {
  switch (props.selectedStep) {
    case MortgageStep.Results:
      return <Results />
    default:
      return <Application />
  }
}
